import React from 'react'
import RA from 'ra-config'
import SidebarDetail from '../../sidebar-detail'
import { labelForStrategy } from '../../../attributes'
import { descriptionForStrategy } from '../../../config/description'
import { getSidebarGroups } from './sidebar-groups'

const TOOLTIPS = RA.content.strategies.attributeInfoText

function getDescription(aggregate, region) {
  if (!aggregate) {
    return ''
  }

  return descriptionForStrategy(
    aggregate.Name,
    aggregate.Category,
    region.value
  )
}

export default function StategiesSidebarDetail({ activeAggregate, region }) {
  let description = getDescription(activeAggregate, region)
  let sidebarGroups = getSidebarGroups(activeAggregate)

  return (
    <SidebarDetail
      aggregate={activeAggregate}
      tooltips={TOOLTIPS}
      getLabel={labelForStrategy}
      sidebarGroups={sidebarGroups}
      description={description}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/strategies/aggregate/sidebar-detail.js